// @vendors
const Immutable = require('immutable');

// @constants
const {
    SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE,
} = require('constants/actionTypes');
const actionTypes = require('../raConstants/actionTypes');
const { FIRST_STEP } = require('constants/index');

const initialState = Immutable.fromJS({
    steps: [
        {
            valid: false,
            errorFlags: false,
        },
    ],
    visibleStep: -1,
    submitSuccessful: false,
    isFetching: false,
    inProgress: false,
});

const RACancelPeriodicContributions = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_FINISH:
            return state.merge({
                submitSuccessful: true,
            });
        case actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_SET_VISIBLE_STEP:
            return state
                .merge({
                    visibleStep: action.payload.step,
                })
                .setIn(['steps', FIRST_STEP, 'valid'], {
                    valid: true,
                });
        case actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_REQUEST:
            return state.merge({
                inProgress: true,
            });
        case actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_SUCCESS:
            return state.merge({
                inProgress: false,
                submitSuccessful: true,
            });
        case actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_FAILURE:
            return state.merge({
                inProgress: false,
            });
        case SIGNATURE_PATTERN_SMS_VALIDATION_FAILURE:
            return state.merge({
                inProgress: false,
            });
        case actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_RESET:
            return initialState;
        default:
            return state;
    }
};

module.exports = RACancelPeriodicContributions;
